import { render } from "./login-phone.vue?vue&type=template&id=3ce25113&scoped=true&ts=true"
import script from "./login-phone.vue?vue&type=script&lang=ts"
export * from "./login-phone.vue?vue&type=script&lang=ts"

import "./login-phone.vue?vue&type=style&index=0&id=3ce25113&scoped=true&lang=css"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce25113"]])

export default __exports__